import config from '@/config'

export default ($axios) => {
    return {
        getCustomList(p, limit, queryParams = {}) {
            const data = {
                p: p,
                limit: limit,
                queryParams: queryParams,
                action: '/custom/get-custom-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        addCustom(param = {}) {
            const data = {
                param: param,
                action: '/custom/add-custom'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        deleteCustom(id) {
            const data = {
                id: id,
                action: '/custom/delete-custom'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        uploadDir(id, order_id, param = []) {
            const data = {
                id: id,
                order_id: order_id,
                param: param,
                action: '/custom/upload-dir'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getOrderInfo(sn) {
            const data = {
                sn: sn,
                action: '/custom/get-order-info'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        uploadFile(id, param) {
            const data = {
                id: id,
                param: param,
                action: '/custom/upload-file'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        orderAdd(id, sn, sn2, param = []) {
            const data = {
                id: id,
                sn: sn,
                sn2: sn2,
                param: param,
                action: '/custom/order-add'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getOrderList(p, limit, status=0,search_key='') {
            const data = {
                p: p,
                limit: limit,
                status: status,
                search_key:search_key,
                action: '/custom/get-order-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        deleteOrder(id) {
            const data = {
                id: id,
                action: '/custom/delete-order'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

         cancelOrder(id) {
            const data = {
                id: id,
                action: '/custom/cancel-order'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        orderLayout(sn, canvas_width,canvas_height, gap,num) {
            const data = {
                sn: sn,
                canvas_width: canvas_width,
                canvas_height:canvas_height,
                gap: gap,
                num:num,
                action: '/custom/order-layout'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        checkCustomerName(name) {
            const data = {
                name: name,
                action: '/custom/check-customer-name'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        deleteOrderPic(id) {
            const data = {
                id: id,
                action: '/custom/delete-order-pic'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        layoutSave(sn, param,canvas_width,gap,margin) {
            const data = {
                action: '/custom/layout-save',
                sn: sn,
                canvas_width: canvas_width,
                gap: gap,
                margin: margin,
                param: param,
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        createSn(id) {
            const data = {
                id: id,
                action: '/custom/create-sn'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        checkFileName(id, name, type,is_check_all=0) {
            const data = {
                id: id,
                name: name,
                type: type,
                is_check_all:is_check_all,
                action: '/custom/check-file-name'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getFileList(path, owner, tab = 1, orderkey,orderby,search_key = '') {
            const data = {
                path: path,
                owner: owner,
                tab: tab,
                orderkey: orderkey,
                orderby:orderby,
                search_key: search_key,
                action: '/custom/get-file-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getCustomInfo(pid) {
            const data = {
                pid: pid,
                action: '/custom/get-custom-info'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        saveCustomInfo(param) {
            const data = {
                param: param,
                action: '/custom/save-custom-info'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        confirmPic(id) {
            const data = {
                id: id,
                action: '/custom/confirm-pic'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        terminationPic(id) {
            const data = {
                id: id,
                action: '/custom/termination-pic'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        uploadVersion(param) {
            const data = {
                param: param,
                action: '/custom/upload-version'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        getHistoryVersionsList(id) {
            const data = {
                id: id,
                action: '/custom/get-history-versions-list'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getHanderHistory(path, owner) {
            const data = {
                path: path,
                owner: owner,
                action: '/custom/get-hander-history'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        checkTypeName(owner,  type) {
            const data = {
                owner: owner,
                type: type,
                action: '/custom/check-type-name'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        fileAdd(owner,path,  param = []) {
            const data = {
                owner: owner,
                path: path,
                param: param,
                action: '/custom/file-add'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        saveCustomUserOne(pid,user_id) {
            const data = {
                pid: pid,
                user_id:user_id,
                action: '/custom/save-custom-user-one'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        saveCustomUserTwo(pid,user_id) {
            const data = {
                pid: pid,
                user_id:user_id,
                action: '/custom/save-custom-user-two'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        delCustomUserTwo(pid,user_id) {
            const data = {
                pid: pid,
                user_id:user_id,
                action: '/custom/del-custom-user-two'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getFileNames(id, name) {
            const data = {
                id: id,
                name: name,
                action: '/custom/get-file-names'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         getCustomListOrder(search_key) {
             const data = {
                search_key:search_key,
                action: '/custom/get-custom-list-order'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
          getPicInfo(id) {
            const data = {
                id: id,
                action: '/custom/get-pic-info'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        savePicMark(param) {
            const data = {
                param: param,
                action: '/custom/save-pic-mark'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        savePicType(param) {
            const data = {
                param: param,
                action: '/custom/save-pic-type'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        orderPicAdd(sn, param = {}) {
            const data = {
                sn: sn,
                param: param,
                action: '/custom/order-pic-add'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        orderPicNum( order_pic_id,num) {
            const data = {
                order_pic_id: order_pic_id,
                num:num,
                action: '/custom/order-pic-num'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        orderPicConfirm( order_pic_id) {
            const data = {
                order_pic_id: order_pic_id,
                action: '/custom/order-pic-confirm'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
           
        orderPicSelect(sn, pid_ic,order_pic_id) {
            const data = {
                sn: sn,
                pid_ic: pid_ic,
                order_pic_id:order_pic_id,
                action: '/custom/order-pic-select'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
        getOrderLayout(sn) {
            const data = {
                sn: sn,
                action: '/custom/get-order-layout'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        
        orderLayoutData(sn, is_gcd) {
            const data = {
                sn: sn,
                is_gcd:is_gcd,
                action: '/custom/order-layout-data'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

         orderLayoutDataGcd(sn, order_pic_ids,gcd) {
            const data = {
                sn: sn,
                order_pic_ids: order_pic_ids,
                gcd:gcd,
                action: '/custom/order-layout-data-gcd'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         
         getLittlePic(sn, num1,num2,gcd) {
            const data = {
                sn: sn,
                num1: num1,
                num2: num2,
                gcd:gcd,
                action: '/custom/get-little-pic'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
         
        layoutSavePic(sn, pic_url) {
            const data = {
                action: '/custom/layout-save-pic',
                sn: sn,
                pic_url: pic_url
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },

        checkCustomerUser() {
            const data = {
                action: '/custom/check-customer-user'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
           shippingOrder(id) {
            const data = {
                id: id,
                action: '/custom/shipping-order'
            }
            return $axios.post(config.VUE_APP_BASE_API_ROUTE, data)
        },
    }
}